import React from 'react';
export function PainSection() {
  return <section className="border-b border-brand-line bg-white px-4 py-4" data-id="element-123" data-mp="1rruahoo2vtz4">
      <div className="mx-auto max-w-3xl space-y-3" data-id="element-124" data-mp="38wvk0gnqsznf">
        <article data-id="element-125" data-mp="38vkgmhy7ltwu">
          <h2 className="mb-1 text-center font-display text-[19px] leading-tight sm:text-[28px]" data-id="element-126" data-mp="2uyfcwolyx74r">
            Stop managing every maintenance task from scratch
          </h2>
          <p className="text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-127" data-mp="2z1lhlrtfmq94">
            Preventive maintenance overdue? Inspections, repairs and work orders piling up?
            Equipment, parts, records, priorities… what needs attention first?{' '}
            <span className="font-bold text-brand-carbon" data-id="element-128" data-mp="2bbr6beorh9qz">MAINTENANCE READY™</span> gives you an
            organized maintenance system to help you manage daily tasks, inspections, preventive
            work and repairs with a clearer workflow.{' '}
            <span className="font-bold text-brand-carbon" data-id="element-129" data-mp="278bb8mscbhge">Inspect. Organize. Maintain.</span>
          </p>
        </article>

        <article className="rounded-xl border-l-4 border-brand-yellow bg-brand-paper p-3" data-id="element-130" data-mp="3rlzhfbze1znc">
          <h2 className="mb-1 font-display text-[17px] leading-tight sm:text-2xl" data-id="element-131" data-mp="3nm746lz1v5bn">
            😩 Stop rebuilding your maintenance process every day
          </h2>
          <p className="text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-132" data-mp="5dgbeiqbl14f">
            You already know maintenance. The problem is wasting time creating checklists,
            organizing work orders and figuring out what needs attention next. Open the system,
            identify the task and use the relevant maintenance tool.{' '}
            <span className="font-bold text-brand-carbon" data-id="element-133" data-mp="3in4afxoisliz">
              Less improvising. More structured maintenance.
            </span>
          </p>
        </article>
      </div>
    </section>;
}